import React from 'react';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Buscás guías de TP de PLC y todo está en inglés, desactualizado o pensado para ingenieros universitarios', 'Explicar lógica de control Ladder sin ejercicios prácticos listos para que el alumno resuelva en el taller', 'Armás tus fichas de automatización desde cero cada semana porque no existe nada para secundaria técnica', 'Evaluaciones improvisadas sin criterios claros de corrección para trabajos prácticos de PLC', 'No hay conexión entre la teoría del aula y lo que el alumno toca en el panel de control', 'Terminás el domingo a las 11 de la noche con el cursor parpadeando en un Word en blanco'];
  return <section className="py-10 md:py-16 px-4 bg-brand-dark" data-id="element-160">
      <div className="max-w-3xl mx-auto" data-id="element-161">
        <h2 className="text-2xl md:text-4xl font-black text-center mb-6 text-white leading-tight" data-id="element-162">
          💣 ¿CUÁNTOS DOMINGOS MÁS VAS A PERDER ASÍ?
        </h2>

        <p className="text-sm md:text-base text-gray-400 mb-8 text-center max-w-2xl mx-auto leading-relaxed" data-id="element-163">
          Sos docente en una escuela técnica industrial. Enseñás automatización,
          PLC, sistemas de control o taller de electromecánica… Pero nadie te
          dio un sistema pensado para la realidad del taller argentino.
        </p>

        <div className="bg-brand-card border-l-4 border-brand-accent p-5 md:p-6 rounded-r-lg mb-10" data-id="element-164">
          <div className="space-y-3" data-id="element-165">
            {points.map((point, index) => <div key={index} className="flex items-start" data-id="element-166">
                <XCircle className="w-5 h-5 text-red-500 mr-3 shrink-0 mt-0.5" data-id="element-167" />
                <p className="text-sm md:text-base text-gray-300 font-medium" data-id="element-168">
                  {point}
                </p>
              </div>)}
          </div>
        </div>

        <div className="text-center mb-8" data-id="element-169">
          <p className="text-lg md:text-xl font-bold text-brand-accent mb-2 neon-glow" data-id="element-170">
            👉 No es falta de vocación. Es falta de un sistema.
          </p>
        </div>

        <div className="text-center" data-id="element-171">
          <h3 className="text-xl md:text-3xl font-black text-white" data-id="element-172">
            💡 ¿Y SI ESTE FUERA EL ÚLTIMO DOMINGO ASÍ?
          </h3>
        </div>
      </div>
    </section>;
}